import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import {
    leaveAiTraining,
    openAiTrainingMode,
} from '../../../utils/aiNavigation'

import NavBar from '../NavBar'
import './ChoseTrainingDevice.css'

import selectbarY from '../../../Assets/Bisoft_UI/AppMode/selectbar.png'
import renderImage from '../../../source/importImg'
import AiModeFooter from './AiModeFooter/AiModeFooter'
import DialogModal from '../../ReusableComponents/DialogModal/DialogModal'
import { appAiBytesGeneration } from './AppModeAiBytesGeneration'
import { getDeviceName, isAi1ShowCondition } from '../../../utils/utils'

const tabs = {
    camera: {
        id: 1,
        title: 'Camera',
        // defaultDevice: 'Ace',
        content: {
            // motion: {
            //     detectionMode: 'Motion',
            //     activeImage: 'aiObjectActive',
            //     InactiveImage: 'aiObjectInActive',
            // },
            // color: {
            //     detectionMode: 'Color',
            //     activeImage: 'aiColorActive',
            //     InactiveImage: 'aiColorinActive',
            // },
            face: {
                detectionMode: 'Face',
                activeImage: 'aiFaceActive',
                InactiveImage: 'aiFaceInActive',
            },
            // object: {
            //     detectionMode: 'Object',
            //     activeImage: 'aiObjectActive',
            //     InactiveImage: 'aiObjectInActive',
            // },
        },
    },
    speech: {
        id: 2,
        title: 'Speech',
        content: {
            speech: {
                detectionMode: 'Speech',
                activeImage: 'aiSpeechActive',
                InactiveImage: 'aiSpeechInActive',
            },
        },
    },
}
const nextPageUrl = {
    face: '/faceTrain',
    color: '/colorTrain',
    speech: '/train',
}
const localStorageAiTrainListKey = {
    face: 'faceTranList',
    color: 'colorTranList',
    speech: 'speechTranList',
}

function ChoseTrainingDevice(props) {
    // const [tabFocus, setTabFocus] = useState('camera')
    // const [detectionModeFocus, setDetectionModeFocus] = useState(-1)
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    // const [erasePopup, setErasePopup] = useState(false)
    // const [isSelectPopup, setIsSelectPopup] = useState(false)
    // const [isClean, setIsClean] = useState(false)
    const [isShowLowerPcAiToolPopup, setIsShowLowerPcAiToolPopup] =
        useState(false)
    const [showPopup, setShowPopup] = useState({
        isShow: false,
        message: '',
        action: '',
    })
    const [tabFocusModeContent, setTabFocusModeContent] = useState(
        tabs['camera'].content
    )
    const detectionModeFocus = props.chooseTrainingDevice.detectionModeFocus
    const tabFocus = props.chooseTrainingDevice.tabFocus
    const history = useHistory()
    // const sendDataAsPacket = useRef({ dataSend: false, replay: '' })
    const sendDataAsPacket = useRef({
        byteSend: false,
        responseMessage: '',
    })

    const timeoutPromise = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                console.log('HHHHHHHHHH Time Out')
                sendDataAsPacket.current = {
                    byteSend: false,
                    responseMessage: '',
                }
                reject(new Error('Timeout exceeded'))
            }, ms)
        })
    }

    const checkOk = async () => {
        return new Promise(async (resolve, reject) => {
            while (true) {
                // if (!sendDataAsPacket.current) {
                //     return resolve()
                // }
                if (!sendDataAsPacket.current.byteSend) {
                    return resolve(sendDataAsPacket.current.responseMessage)
                }

                await new Promise((reslove) => {
                    setTimeout(reslove, 100)
                })
            }
        })
    }

    //get the contents of each tabs
    useEffect(() => {
        Object.keys(tabFocus).map((objKey) => {
            if (tabFocus[objKey]) {
                setTabFocusModeContent(tabs[objKey].content)
            }
        })
    }, [tabFocus])

    const backButtonClick = () => {
        shouldEraseYes()
        // setShowPopup({
        //     isShow: true,
        //     message:
        //         'All Unsaved program will be Erased. Are you sure want to continue ?',
        //     action: 'erase',
        // })
    }
    const nextButtonClick = () => {
        try {
            let optionSelect = false
            // let aiTrainList =
            //     localStorage.getItem('aiTrainList') ||
            //     JSON.stringify({
            //         colorTranList: [],
            //         faceTranList: [],
            //         speechTranList: [],
            //         connectedDevice,
            //     })
            // aiTrainList = JSON.parse(aiTrainList)

            let selectedDevice = ''
            const { speech, camera } = props.chooseTrainingDevice.tabFocus
            // Object.keys(detectionModeFocus).map((objKey) => {
            //     if (detectionModeFocus[objKey]) {
            //         optionSelect = true
            //         selectedDevice = objKey
            //     }
            // })

            if (speech && detectionModeFocus.speech) {
                selectedDevice = 'speech'
            } else if (camera && detectionModeFocus.face) {
                selectedDevice = 'face'
            } else {
                selectedDevice = ''
            }

            //if any option not selected show popup
            if (
                !selectedDevice
                // (speech && selectedDevice !== 'speech') ||
                // (camera && selectedDevice !== 'face')
            ) {
                setShowPopup({
                    isShow: true,
                    message:
                        'Please select the option before click on next button.',
                    action: 'selectDevice',
                })
                return
            }

            if (['color', 'face', 'speech'].includes(selectedDevice)) {
                let isCleanTrain = false
                if (selectedDevice == 'color') {
                    isCleanTrain = props.colorTrain.isCleanTrain
                }
                if (selectedDevice == 'speech') {
                    isCleanTrain = props.speechTrain.isCleanTrain
                } else {
                    isCleanTrain = props.faceTrain.isCleanTrain
                }

                if (
                    !isCleanTrain
                    // !redux_isUpload_true_check
                    // &&
                    // aiTrainList[localStorageAiTrainListKey[selectedDevice]]
                    //     ?.length > 0
                ) {
                    setShowPopup({
                        isShow: true,
                        message:
                            selectedDevice === 'speech'
                                ? 'Do you want to delete the previous speech training and train new speech?'
                                : `Do you want to delete the previous ${selectedDevice} and train a new ${selectedDevice}?`,
                        action: 'clean',
                    })
                    return
                }
            }

            openAiTrainingMode(history, nextPageUrl[selectedDevice])
        } catch (e) {
            console.log('ERROR', e)
        }
    }

    //handel click on tabs mode and update thr redux
    const handelTabClick = (ele) => {
        // setDetectionModeFocus(ele)
        let newTabFocus = {
            ...props.chooseTrainingDevice.tabFocus,
        }
        Object.keys(newTabFocus).map((objKey) => (newTabFocus[objKey] = false))
        newTabFocus[ele] = true
        props.setAppAiModeStorage({
            tabFocus: newTabFocus,
            type: 'tabFocus',
        })
    }

    //handel click on detection mode and update thr redux
    const detectionModeClick = (ele) => {
        // setDetectionModeFocus(ele)
        let newDetectionModeFocus = {
            ...props.chooseTrainingDevice.detectionModeFocus,
        }
        // Object.keys(newDetectionModeFocus).map(
        //     (objKey) => (newDetectionModeFocus[objKey] = false)
        // )
        newDetectionModeFocus[ele] = true
        props.setAppAiModeStorage({
            detectionModeFocus: newDetectionModeFocus,
            type: 'detectionModeFocus',
        })
    }

    //erased the data
    const shouldEraseYes = () => {
        // sessionStorage.removeItem('appAiModeStorage')
        let newRecoveryData = JSON.parse(
            localStorage.getItem('recoveryData') || JSON.stringify({})
        )

        //delete from redux and session storage
        props.setAppAiModeStorage({
            setAppAiModeStorage: '',
            type: 'RemoveAppAiModeStorage',
        })

        //delete from recovery data
        deleteRecoveryData(
            newRecoveryData,
            'appAiBase',
            connectedDevice,
            deviceVersion
        )
        // history.push('/appMode/selectHardware')
        leaveAiTraining(history)
    }

    //clean the previous ai trains
    const shouldCleanYes = async () => {
        let selectedDevice = ''
        try {
            // let aiTrainList =
            //     localStorage.getItem('aiTrainList') ||
            //     JSON.stringify({
            //         colorTranList: [],
            //         faceTranList: [],
            //         speechTranList: [],
            //         connectedDevice,
            //     })
            // aiTrainList = JSON.parse(aiTrainList)

            // Object.keys(detectionModeFocus).map((objKey) => {
            //     if (detectionModeFocus[objKey]) {
            //         selectedDevice = objKey
            //     }
            // })
            const { speech, camera } = props.chooseTrainingDevice.tabFocus

            if (speech && detectionModeFocus.speech) {
                selectedDevice = 'speech'
            } else if (camera && detectionModeFocus.face) {
                selectedDevice = 'face'
            } else {
                selectedDevice = ''
            }

            let clearBytes = appAiBytesGeneration('cleanByte', selectedDevice)
            sendDataAsPacket.current = { byteSend: true, responseMessage: '' }
            setShowPopup({
                isShow: true,
                message: `Erasing....`,
                action: 'errorMessage',
            })

            props.worker.postMessage({
                type: 'WriteArrayFormat1310',
                value: clearBytes,
            })
            // await new Promise((reslove) => setTimeout(reslove, 2000))
            let replyOK = await Promise.race([
                checkOk(),
                timeoutPromise(1000), //
            ])

            // aiTrainList[localStorageAiTrainListKey[selectedDevice]] = []
            // localStorage.setItem('aiTrainList', JSON.stringify(aiTrainList))

            if (selectedDevice == 'color') {
                let colorTrain = props.colorTrain
                colorTrain.isCleanTrain = true
                props.setAppAiModeStorage({
                    colorTrain: colorTrain,
                    type: 'colorTrain',
                })
            } else if (selectedDevice == 'speech') {
                let speechTrain = props.speechTrain
                speechTrain.isCleanTrain = true
                props.setAppAiModeStorage({
                    speechTrain: speechTrain,
                    type: 'speechTrain',
                })
            } else if (selectedDevice == 'face') {
                let faceTrain = props.faceTrain
                faceTrain.isCleanTrain = true
                props.setAppAiModeStorage({
                    faceTrain: faceTrain,
                    type: 'faceTrain',
                })
            }

            openAiTrainingMode(history, nextPageUrl[selectedDevice])
        } catch (e) {
            console.log('ERROR', e)
            setShowPopup({
                isShow: true,
                message: `Old ${selectedDevice} does not erase, please try again.`,
                action: 'errorMessage',
            })
            // setTimeout(() => {
            //     setShowPopup({
            //         isShow: false,
            //         message: ``,
            //         action: '',
            //     })
            // }, 1500)
        }
    }

    //fetch thr tran face and spech details
    const shouldFetchData = async () => {
        let selectedDevice = ''
        try {
            const { speech, camera } = props.chooseTrainingDevice.tabFocus

            if (speech && detectionModeFocus.speech) {
                selectedDevice = 'speech'
            } else if (camera && detectionModeFocus.face) {
                selectedDevice = 'face'
            } else {
                selectedDevice = ''
            }

            if (selectedDevice === 'face') {
                let faceListByte = appAiBytesGeneration('getFaceListByte')
                sendDataAsPacket.current = {
                    byteSend: true,
                    responseMessage: '',
                }
                setShowPopup({
                    isShow: true,
                    message: `Fetching....`,
                    action: 'errorMessage',
                })

                props.worker.postMessage({
                    type: 'aiFetchAudioWriteArray',
                    value: faceListByte,
                })
                // await new Promise((reslove) => setTimeout(reslove, 2000))
                let replyOK = await Promise.race([
                    checkOk(),
                    timeoutPromise(1000), //
                ])
            } else if (selectedDevice === 'speech') {
                let faceListByte = appAiBytesGeneration('getSpeechListByte')
                sendDataAsPacket.current = {
                    byteSend: true,
                    responseMessage: '',
                }
                setShowPopup({
                    isShow: true,
                    message: `Fetching....`,
                    action: 'errorMessage',
                })

                props.worker.postMessage({
                    type: 'aiFetchAudioWriteArray',
                    value: faceListByte,
                })
                // await new Promise((reslove) => setTimeout(reslove, 2000))
                let replyOK = await Promise.race([
                    checkOk(),
                    timeoutPromise(1000), //
                ])
            }
        } catch (e) {
            console.log('ERROR', e)
            setShowPopup({
                isShow: true,
                message: `Old ${selectedDevice} does not fetch, please try again.`,
                action: 'errorMessage',
            })
        }
    }

    const getDialogModelOption = (actinName) => {
        try {
            if (actinName === 'clean') {
                return [
                    {
                        text: 'YES',
                        do: () => shouldCleanYes(),
                    },
                    {
                        text: 'NO',
                        do: () => shouldFetchData(),
                        // setShowPopup({
                        //     isShow: false,
                        //     message: '',
                        //     action: '',
                        // }),
                    },
                ]
            } else if (actinName === 'erase') {
                return [
                    {
                        text: 'YES',
                        do: () => shouldEraseYes(),
                    },
                    {
                        text: 'NO',
                        do: () =>
                            setShowPopup({
                                isShow: false,
                                message: '',
                                action: '',
                            }),
                    },
                ]
            } else return []
        } catch (e) {
            console.log('ERROR', e)
        }
    }

    // its save the setAppAiModeStorage data in local storage
    const saverecoveryData = () => {
        let newAppAiModeStorage = {}
        let newRecoveryData = JSON.parse(
            localStorage.getItem('recoveryData') || JSON.stringify({})
        )
        try {
            newAppAiModeStorage = JSON.parse(
                sessionStorage.getItem('appAiModeStorage')
            )
        } catch (e) {
            console.log('ERROR', e)
        }

        //create the recoveryData object
        function addData(baseType, connectedDevice, deviceVersion, data) {
            if (!newRecoveryData[baseType]) {
                newRecoveryData[baseType] = {}
            }
            if (!newRecoveryData[baseType][connectedDevice]) {
                newRecoveryData[baseType][connectedDevice] = {}
            }
            if (!newRecoveryData[baseType][connectedDevice][deviceVersion]) {
                newRecoveryData[baseType][connectedDevice][deviceVersion] = {}
            }
            newRecoveryData[baseType][connectedDevice][
                deviceVersion
            ].appAiModeStorage = data
        }

        addData(
            'appAiBase',
            connectedDevice,
            deviceVersion,
            newAppAiModeStorage
        )

        localStorage.setItem('recoveryData', JSON.stringify(newRecoveryData))
    }

    //delete the data from recovery object
    function deleteRecoveryData(newRecoveryData, baseType, device, version) {
        if (newRecoveryData[baseType] && newRecoveryData[baseType][device]) {
            delete newRecoveryData[baseType][device][version]

            // If the device has no more versions, delete the device
            if (Object.keys(newRecoveryData[baseType][device]).length === 0) {
                delete newRecoveryData[baseType][device]
            }

            // If the baseType has no more devices, delete the baseType
            if (Object.keys(newRecoveryData[baseType]).length === 0) {
                delete newRecoveryData[baseType]
            }
        }
        localStorage.setItem('recoveryData', JSON.stringify(newRecoveryData))
    }

    //AI STOP TARIN bytes sending
    const sendStopTrainBytes = async () => {
        try {
            let getStoTrainBytes = appAiBytesGeneration('stopTrainByte')

            props.worker.postMessage({
                type: 'aiFetchAudioWriteArray',
                value: getStoTrainBytes,
            })
        } catch (e) {
            console.error(e)
        }
    }

    //if user close the window its save the createActionState data in local storage
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            saverecoveryData()
        }

        const regexPattern = /^65,73,.*255,245$/
        const fetchRegex = (num) =>
            new RegExp(
                `^65,76,\\d+,\\d+,${num},13,10,((?:\\d+,)*?)\\d+,255,245$`
            )

        //slice the bigining ,13,10,
        const parseMatchArray = (matchString) =>
            matchString.slice(0, -1).split(',13,10,')

        const processSpeechData = (matchArr) => {
            const speechTrain = structuredClone(props.speechTrain)
            const resultArr = []
            let heighestIndex = 0

            if (matchArr.length > 1) {
                for (let i = 0; i < matchArr.length - 1; i += 2) {
                    const labelArr = matchArr[i + 1].split(',')
                    const id = parseInt(matchArr[i])
                    resultArr.push({
                        label: String.fromCharCode(...labelArr),
                        id,
                    })
                    if (id !== 101 && id > heighestIndex) heighestIndex = id
                }

                const speechQueryArr = Array.from(
                    { length: heighestIndex },
                    (_, i) => {
                        const match = resultArr.find((el) => el.id === i + 1)
                        return { value: match?.label || '' }
                    }
                )

                const wakeWord = resultArr.find((el) => el.id === 101)?.label

                Object.assign(speechTrain, {
                    speechQueryArr,
                    wakeWord,
                    isCleanTrain: true,
                })
            }

            speechTrain.isCleanTrain = true
            props.setAppAiModeStorage({ speechTrain, type: 'speechTrain' })
            sendStopTrainBytes()
            openAiTrainingMode(history, '/train')
        }

        const processFaceData = (matchArr) => {
            const faceTrain = structuredClone(props.faceTrain)

            if (matchArr.length > 1) {
                faceTrain.tranList = matchArr.slice(0, -1).flatMap((_, i) => {
                    if (i % 2 === 0) {
                        const id = parseInt(matchArr[i])
                        const label = String.fromCharCode(
                            ...matchArr[i + 1].split(',')
                        )
                        return [
                            {
                                id,
                                title: label,
                                faceName: label,
                                isUpload: true,
                            },
                        ]
                    }
                    return []
                })

                if (faceTrain.tranList.length < 3) {
                    faceTrain.tranList.push({
                        title: 'Face',
                        faceName: '',
                        isUpload: false,
                        id: 0,
                    })
                }

                faceTrain.focusInd = 0
            }
            faceTrain.isCleanTrain = true

            props.setAppAiModeStorage({ faceTrain, type: 'faceTrain' })
            // no stop-train (0x00) before face training; the mobile app only
            // sends enable AI ports (0x58), done on the face-train screen
            openAiTrainingMode(history, '/faceTrain')
        }

        const messageHandler = (e) => {
            if (e.data.type !== 'actionRead') return

            const { arrayData } = e.data.value
            const dataString = arrayData.join(',')

            if (regexPattern.test(dataString)) {
                sendDataAsPacket.current = {
                    byteSend: false,
                    responseMessage: arrayData,
                }
                return
            }

            const faceMatch = dataString.match(fetchRegex(31))
            const speechMatch = dataString.match(fetchRegex(21))

            if (speechMatch) {
                const matchArr = parseMatchArray(speechMatch[1])
                processSpeechData(matchArr)
            }

            if (faceMatch) {
                const matchArr = parseMatchArray(faceMatch[1])
                processFaceData(matchArr)
            }
        }

        // const messageHandler = (e) => {
        //     // if (e.data.type === 'read' && e.data.value.includes('AIXOK')) {
        //     if (e.data.type === 'actionRead') {
        //         let { arrayData, stringData } = e.data.value
        //         // sendDataAsPacket.current = false
        //         const pattern = /^65,73,.*255,245$/
        //         let arrayDataStringFormat = arrayData.join(',')
        //         const isPatternMatch = pattern.test(arrayData.join(','))
        //         if (isPatternMatch) {
        //             sendDataAsPacket.current = {
        //                 byteSend: false,
        //                 responseMessage: arrayData,
        //             }
        //         } else {
        //             const fetchRegexEqu = (num) =>
        //                 new RegExp(
        //                     `^65,76,\\d+,\\d+,${num},13,10,((?:\\d+,)*?)\\d+,255,245$`
        //                 )

        //             let fetchFaceMatch = arrayDataStringFormat.match(
        //                 fetchRegexEqu(31)
        //             )
        //             // console.log('HHHHHHHHHH', fetchMatch)
        //             let fetchSpeechMatch = arrayDataStringFormat.match(
        //                 fetchRegexEqu(21)
        //             )

        //             if (fetchSpeechMatch) {
        //                 let speechTrain = JSON.parse(
        //                     JSON.stringify(props.speechTrain)
        //                 )

        //                 let heighestIndex = 0

        //                 const matchArr = fetchSpeechMatch[1]
        //                     .slice(0, -1)
        //                     .split(',13,10,')

        //                 //check if  speech is save or not
        //                 if (matchArr.length > 1) {
        //                     let resultArr = []

        //                     for (
        //                         let i = 0;
        //                         i < matchArr.length - 1;
        //                         i = i + 2
        //                     ) {
        //                         let labelArr = matchArr[i + 1].split(',')

        //                         resultArr.push({
        //                             label: String.fromCharCode(...labelArr),
        //                             id: parseInt(matchArr[i]),
        //                         })

        //                         heighestIndex =
        //                             heighestIndex < parseInt(matchArr[i]) &&
        //                             parseInt(matchArr[i]) !== 101
        //                                 ? parseInt(matchArr[i])
        //                                 : heighestIndex
        //                     }

        //                     let speechQueryArr = []
        //                     for (let i = 0; i < heighestIndex; i++) {
        //                         let obj = { value: '' }
        //                         let objeEle = resultArr.find(
        //                             (ele) => ele.id == i + 1
        //                         )
        //                         if (objeEle) {
        //                             obj.value = objeEle.label
        //                         }
        //                         speechQueryArr[i] = obj
        //                     }

        //                     let objeEle = resultArr.find((ele) => ele.id == 101)
        //                     if (objeEle) {
        //                         speechTrain.wakeWord = objeEle.label
        //                     }
        //                     speechTrain.speechQueryArr = speechQueryArr
        //                 }
        //                 speechTrain.isCleanTrain = true

        //                 props.setAppAiModeStorage({
        //                     speechTrain: speechTrain,
        //                     type: 'speechTrain',
        //                 })

        //                 sendStopTrainBytes()
        //                 history.push(nextPageUrl[selectedDevice])
        //             }

        //             if (fetchFaceMatch) {
        //                 let faceTrain = JSON.parse(
        //                     JSON.stringify(props.faceTrain)
        //                 )

        //                 const matchArr = fetchFaceMatch[1]
        //                     .slice(0, -1)
        //                     .split(',13,10,')

        //                 //check if no face is save or not
        //                 if (matchArr.length > 1) {
        //                     for (
        //                         let i = 0;
        //                         i < matchArr.length - 1;
        //                         i = i + 2
        //                     ) {
        //                         let labelArr = matchArr[i + 1].split(',')

        //                         let name = String.fromCharCode(...labelArr)
        //                         let obj = {
        //                             title: name,
        //                             faceName: name,
        //                             isUpload: true,
        //                             id: parseInt(matchArr[i]),
        //                         }
        //                         faceTrain.tranList[i / 2] = obj
        //                     }
        //                     faceTrain.tranList[faceTrain.tranList.length] = {
        //                         title: 'Face',
        //                         faceName: '',
        //                         isUpload: false,
        //                         id: 0,
        //                     }
        //                     faceTrain.focusInd = 0
        //                 }
        //                 faceTrain.isCleanTrain = true

        //                 props.setAppAiModeStorage({
        //                     faceTrain: faceTrain,
        //                     type: 'faceTrain',
        //                 })

        //                 sendStopTrainBytes()
        //                 history.push(nextPageUrl[selectedDevice])
        //             }
        //         }
        //     }
        // }

        window.addEventListener('beforeunload', handleBeforeUnload)
        props.worker.addEventListener('message', messageHandler)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
            props.worker.removeEventListener('message', messageHandler)
        }
    }, [])
    useEffect(() => {
        if (
            props.isConnected &&
            !isAi1ShowCondition({ connectedDevice, deviceVersion })
        ) {
            setIsShowLowerPcAiToolPopup(true)
        }
    }, [props.isConnected])

    return (
        <div>
            {/* --------- Erased popup -------- */}
            {/* <DialogModal
                show={erasePopup}
                text="All Unsaved program will be Erased. Are you sure want to continue ?"
                showCloseBtn={false}
                // handleDialogModalClose={handleDialogModalClose}
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () => shouldEraseYes(),
                    },
                    {
                        text: 'NO',
                        do: () => setErasePopup(false),
                    },
                ]}
            /> */}

            <DialogModal
                show={isShowLowerPcAiToolPopup}
                text={
                    <p>
                        {`AI-1 accessory is not compatible with the current firmware version. Please update the ${getDeviceName(
                            connectedDevice
                        )} using the firmware updation tool `}
                        <a href="https://firmware.plode.org" target="_blank">
                            Here.
                        </a>
                    </p>
                }
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setIsShowLowerPcAiToolPopup(false)
                }
            />

            {/* --------- not select mode  popup -------- */}
            <DialogModal
                show={showPopup.isShow}
                text={showPopup.message}
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowPopup({
                        isShow: false,
                        message: '',
                        action: '',
                    })
                }
                optionsToSelect={getDialogModelOption(showPopup.action)}
            />

            {/* NavBar */}
            <div>
                <NavBar
                    selectbar={selectbarY}
                    selectbarwidth="24%"
                    headers={[
                        { name: 'Enable', color: 'white' },
                        { name: 'Train', color: 'black' },
                        { name: '', color: 'black' },
                    ]}
                    save={false}
                    showHelp={false}
                    // handleHelp={handleClickhelpbtn}
                />
            </div>
            <div style={{ display: 'flex' }}>
                <aside className="trainingDeviceSidebar">
                    <div className="sidebarDeviceNameDiv">
                        {Object.keys(tabs).map((ele) => {
                            return (
                                <div
                                    style={{
                                        background:
                                            tabFocus[ele] == true
                                                ? 'linear-gradient(90deg, rgb(161, 160, 160), rgb(241, 241, 241))   '
                                                : '',
                                    }}
                                    key={tabs[ele].id}
                                    className="sidebarDeviceName"
                                    onClick={(e) => handelTabClick(ele)}
                                >
                                    <p
                                        style={{
                                            marginBottom: '0px',
                                            marginLeft: '30px',
                                            fontSize: '1.3rem',
                                        }}
                                    >
                                        {tabs[ele].title}
                                    </p>
                                    <div
                                        style={{
                                            display:
                                                tabFocus[ele] == true
                                                    ? 'block'
                                                    : 'none',
                                            marginRight: '30px',
                                        }}
                                    >
                                        <img src={renderImage('arrowRight')} />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </aside>

                <div className="choseTrainingDeviceBody">
                    <div className="detectionModeDiv">
                        {Object.keys(tabFocusModeContent).map((ele, ind) => {
                            return (
                                <div
                                    key={ind}
                                    className="detectionModeEachContent"
                                >
                                    <img
                                        className="detectionModeImg"
                                        src={
                                            detectionModeFocus[ele] === true
                                                ? renderImage(
                                                      tabFocusModeContent[ele]
                                                          .activeImage
                                                  )
                                                : renderImage(
                                                      tabFocusModeContent[ele]
                                                          .InactiveImage
                                                  )
                                        }
                                        alt={ele.detectionMode}
                                        onClick={(e) => detectionModeClick(ele)}
                                    />
                                    <p
                                        className="detectionModeTitel"
                                        onClick={(e) => detectionModeClick(ele)}
                                    >
                                        {tabFocusModeContent[ele].detectionMode}
                                    </p>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            {/* ------- Footer ------- */}
            <AiModeFooter
                isNextShow={true}
                isBackShow={true}
                nextClick={(e) => nextButtonClick()}
                backClick={(e) => backButtonClick()}
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        // appAiModeStorage: state.appAiModeStorage,

        chooseTrainingDevice: state.appAiModeStorage.chooseTrainingDevice,
        worker: state.worker,
        isConnected: state.webSerial.isConnected,
        // colorTranList: state.appAiModeStorage.colorTrain.tranList,
        // faceTranList: state.appAiModeStorage.faceTrain.tranList,

        colorTrain: state.appAiModeStorage.colorTrain,
        faceTrain: state.appAiModeStorage.faceTrain,
        speechTrain: state.appAiModeStorage.speechTrain,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setAppAiModeStorage: (data) => {
            dispatch({ type: 'APP_AI_MODE_STORAGE', payload: data })
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChoseTrainingDevice)
